import React from 'react';
import { ZohoPeopleCard } from './ZohoPeopleCard.component';
import { IntegrationDetailPageShell } from './IntegrationDetailPageShell.component';

export const ZohoPeopleDetailPage = () => (
  <IntegrationDetailPageShell
    logoText="Zoho"
    logoColor="#e8251a"
    title="Zoho People"
    subtitle="Push Prodaff tracked hours to Zoho People as attendance records."
  >
    <ZohoPeopleCard />
  </IntegrationDetailPageShell>
);
